import { MutationOptions } from '@tanstack/react-query';

import { AxiosCartError, Cart, CartIdParam } from '@telialt/models/src/EshopModel';
import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { useLogError } from '@telialt/utils/src/datadog/useLogError';
import { useSegment } from '@telialt/utils/src/segment';

import { ESHOP_MUTATION_KEY } from '../../model';
import { apiCloneCart } from '../../store/api';
import { useMutationWithCartRefresh } from './useMutationWithCartRefresh';

type Config = Omit<MutationOptions<Cart, AxiosCartError, CartIdParam>, 'mutationKey' | 'mutationFn'>;

export const useCloneCartMutation = (config?: Config) => {
    const segment = useSegment();

    const { error, isError, isPending, mutate, status } = useMutationWithCartRefresh(
        async ({ cartId }: CartIdParam) => (await apiCloneCart(segment, { cartId })).data,
        {
            ...config,
            mutationKey: [ESHOP_MUTATION_KEY.CLONE_CART],
        },
    );
    useLogError(error, DDComponent.Eshop);

    return {
        isErrorCloneCart: isError,
        isLoadingCloneCart: isPending,
        cloneCart: mutate,
        statusCloneCart: status,
        cloneCartError: error,
    };
};
